import { Component, EventEmitter, Input, Output, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { IonSearchbar, Platform, PopoverController } from '@ionic/angular';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { KeywordsService } from 'src/app/services/lobby/keywords.service';
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { LobbyStateService } from 'src/app/services/lobbyState/lobby-state.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchbarComponent implements OnInit {
  @ViewChild(IonSearchbar) myInput: IonSearchbar;
  @ViewChild('inputEl') inputElRef;
  @Input() data: any;
  public searchInput: string = ''; 
  public filterTerm: string = '';  
  public subscriptionFocus: Subscription;
  public keyWordsArray: any = [];
  public gameListData: any = [];
  public keyWordQueryChanged: Subject<any> = new Subject<any>();
  public focus$: Subject<string> = new Subject<string>();
  public keyWordsListData: any;
  public isLoggedIn = false;
  public showKeyWords: boolean = true;
  public isAuthenticated: boolean = false;
  public imagesPath;
  private isIosWeb = false;
  // 'https://sdtest-cdn.palainteractive.com/assets/social/games/'; // this.LobbyService.galleryImagePath;


  constructor(
    public events: EventsService,
    public gameHubController: GameHubControllerService,
    public lobbyNavigator: LobbyNavigator,
    public lobbyService: LobbyService,
    public lobbyState: LobbyStateService,
    public popoverController: PopoverController,
    public keywordsService: KeywordsService,
    public userSession: UserSessionService,
    public navigator: Navigator,
    public platform: Platform,
  ) {
    const isMobileWeb = this.platform.is('mobileweb');
    const isIOS = this.platform.is('ios');
    this.isIosWeb = isMobileWeb && isIOS;

    this.keyWordQueryChanged
      .pipe(debounceTime(50), distinctUntilChanged())
      .subscribe(model => {
        if (model.length > 2) {
          this.showKeyWords=false;
          this.keyWordsArray = model;
          this.lobbyState.setSearchTerm(this.keyWordsArray);
        
        } else {
          this.filterTerm=''; 
          this.showKeyWords=true;
          this.keyWordsArray = []; 
        }
      });

    this.subscriptionFocus = this.focus$
      .pipe(debounceTime(25))
      .subscribe(
        (ev) => {
          this.onFocus(ev)
        }
      );

    this.userSession.isAuthenticated().then(res => {
      if (res) {
        this.isAuthenticated = true;
      }
    });
  }

  ngOnInit() {
    this.imagesPath = this.lobbyService.galleryImagePath;
    this.userSession.getCustomer().subscribe((customer) => {
      this.userSession.isAuthenticated().then(res => {
        this.isLoggedIn = res;
      })
    });
    this.keyWordsListData = this.data.keyWordsListData;
    this.keyWordsListData = this.keyWordsListData.filter(k => {
      return k.action_type === "gamelist";
    })

    this.gameListData = this.data.gamesListData;
    setTimeout(() => { this.myInput.setFocus(); }, 150);

    //added for ios web. https://stackoverflow.com/a/53012530
    setTimeout(() => {
        try {
            this.inputElRef?.nativeElement?.querySelector('input').focus();
        } catch (error) {
            console.log("ios web focus searchbar error", error)
        }
    }, 200);
  }

  ionViewWillLeave() {
    this.events.publish('events:searchbar:showButton');
  }


  onDataSelected(data) {
    this.showKeyWords = false;
    this.events.publish('searchbar:keyword:click', data);
    return this.onSearchbarcancel();
  }

  onFieldChange(keywordQuery) {
    this.searchInput = keywordQuery; 
    this.showKeyWords =  keywordQuery.length < 3 ? true : false;
  
 
    if (keywordQuery.length > 2) {
      this.filterTerm = keywordQuery;
      this.keyWordQueryChanged.next(keywordQuery);
    } else {
      this.filterTerm = ''; // Reset filter term
    }
  }

  onFocus(ev: any) {
    this.showKeyWords = true;
    // event:searchbar is communicating to src\modules\lobby\pages\casino\casino.ts
    //KP this.events.publish("event:searchbar:active");
  }

  onGameClick(gameData) {
    if(gameData.is_demoPlay){
      this.navigateToGameDetails(gameData);
    } else {
      this.launchCasinoGame(gameData);
    }
  }

  navigateToGameDetails(gameData) {
    this.onSearchbarcancel();
    this.navigator.navigateTo('GameDetailsComponent', { multipleModals: false }, { gamedata: gameData });
  }

  launchCasinoGame(gameData) {
    if (!this.isAuthenticated) {
      if (this.checkIfLiveGame(gameData)) {
        setTimeout(() => {
          this.singleMultipleLiveDealerFlow(gameData);
          return this.onLogin();
        }, 500);
      } else {
        this.lobbyService.setWaitingGameData(gameData);
        return this.onLogin();
      }
    }
    else {
      this.closeGame();
      this.onSearchbarcancel();
      //if (this.checkIfLiveGame(gameData)) return this.liveGameWorkflow(gameData);
      if (this.checkIfLiveGame(gameData)) {
        this.singleMultipleLiveDealerFlow(gameData);
        this.lobbyNavigator.toKeyTab(this.lobbyService.getLiveDealerKeywordName() ? this.lobbyService.getLiveDealerKeywordName() : 'Live dealer');
        return this.liveGameWorkflow(gameData);
      } else {
        this.lobbyNavigator.selecHomeIfnotGameList();
        return this.launchGame(gameData);
      }
      
    }
  }

  private launchGame(gameData: any): any{
    return setTimeout(() => this.gameHubController.launchCasinoGame(gameData), 300);
  }

  private liveGameWorkflow(gameData: any): any{
    return this.lobbyNavigator.liveDealerBonusPopover(gameData);
  }

  private checkIfLiveGame = (gameData: any): Boolean => gameData.super_type == 'LIVE_DEALER'? true : false;

  onLogin() {
    this.navigator.navigateTo("LoginComponent");
  }

  closeGame() {
    this.events.publish("event:game:close");
    this.gameHubController.killAllInstances();
  }

  ngOnDestroy() {
    this.subscriptionFocus.unsubscribe();
  }

  onSearchbarcancel() {
    this.popoverController.dismiss();
  }

  singleMultipleLiveDealerFlow(gameData){
    let subCategoryData;
    if (this.checkIfLiveGame(gameData)){
      this.keywordsService.getLiveDealerKeywordInfo().subscribe(res => {
        if (res && res.subKeywords?.length > 0) {
          this.lobbyService.setLiveDealerKeywordName(res?.name);
          subCategoryData = res?.subKeywords.filter(entry => {
            const actionParam = JSON.parse(entry.action_param);
            return actionParam.vendor === gameData.vendor_name;
          });
          this.lobbyService.setWaitingGameData(subCategoryData);
          this.lobbyNavigator.selectKeyword(res);
          //this.lobbyNavigator.setCurrentTab('livedealer')
        } else {
          this.lobbyService.setLiveDealerKeywordName(res?.name);
          subCategoryData = gameData;
          this.lobbyService.setWaitingGameData(subCategoryData);
          //this.lobbyNavigator.setCurrentTab('livedealer')
        }
      }).unsubscribe();
  }
}
}


